<template>
  <div class="c-footer">
    <div class="c-footer-content-greater1200">
      <!-- <div class="c-footer-content">
        <img class="c-footer-logo" src="@/assets/images/footer/footer-logo.svg" alt="">
      </div> -->
      <div class="c-footer-split"></div>
      <div class="c-footer-block">
        <div class="c-footer-main">
          <div class="c-footer-list" v-for="(obj, i) in baseData.guideList" :key="i">
            <div class="c-footer-list-type">{{ obj.name }}</div>
            <div class="c-footer-list-label" v-for="(item, j) in obj.list" @click="openUrl(item.url, item.event)" :key="j"> {{ item.label }}</div>
          </div>

          <div class="c-footer-ver-split"></div>

          <div class="c-footer-list">
            <div class="c-footer-list-type pl28" :style="`background-image: url(${baseData.contact.phone.icon})`">
              {{ baseData.contact.phone.label }}</div>
            <div class="c-footer-list-label mt4 mb26 indent">{{ baseData.contact.phone.value }}</div>
            <div class="c-footer-list-type pl28" :style="`background-image: url(${baseData.contact.time.icon})`">
              {{ baseData.contact.time.label }}</div>
            <div class="c-footer-list-label mt4 mb26 indent">{{ baseData.contact.time.value }}</div>
            <div class="c-footer-list-type pl28" :style="`background-image: url(${baseData.contact.qr.icon})`">
              {{ baseData.contact.qr.label }}</div>
            <img class="qrcodeImg indent" :src="baseData.contact.qr.img" alt="">
          </div>
        </div>
      </div>
    </div>

    <div class="c-footer-content1200">
      <!-- <div class="c-footer-content">
        <img class="c-footer-mini-logo" src="@/assets/images/footer/mini-footer-logo.svg" alt="">
      </div> -->
      <div class="c-footer-split"></div>
      <div class="c-footer-content c-footer-mini-block">
        <div class="c-footer-mini-main">
          <div v-for="obj in baseData.guideList">
            <div class="c-footer-list-mini-type" @click="clickType(obj.info)">{{ obj.name }}
              <span>
                <img :class="foldMenu[obj.info] ? 'imgTransform' : ''" src="@/assets/images/footer/ico-arrow.png">
              </span>
            </div>
            <div v-if="foldMenu[obj.info]" class="c-footer-list-mini-type c-footer-list-mini-label"
              v-for="item in obj.list" @click="openUrl(item.url, item.event)"> {{ item.label }}
            </div>
          </div>

          <div class="c-footer-min-contact">
            <div>
              <div class="c-footer-min-contact-label" :style="`background-image: url(${baseData.contact.qr.icon})`">
                {{ baseData.contact.qr.label }}</div>
              <img class="qrcodeImg" :src="baseData.contact.qr.img" alt="">
            </div>
            <div>
              <div class="c-footer-min-contact-label" :style="`background-image: url(${baseData.contact.phone.icon})`">
                {{ baseData.contact.phone.label }}</div>
              <div class="c-footer-min-contact-value">{{ baseData.contact.phone.value }}</div>
            </div>
            <div>
              <div class="c-footer-min-contact-label" :style="`background-image: url(${baseData.contact.time.icon})`">
                {{ baseData.contact.time.label }}</div>
              <div class="c-footer-min-contact-value">{{ baseData.contact.time.value }}</div>
            </div>


            <!-- <div class="c-footer-list-type pl28" :style="`background-image: url(${baseData.contact.qr.icon})`">
              {{ baseData.contact.qr.label }}</div>
            <img class="qrcodeImg" :src="baseData.contact.qr.img" alt=""> -->
          </div>
        </div>
      </div>
    </div>




    <div class="c-footer-split mt72"></div>
    <div class="c-footer-content c-footer-copyright-block">
      <div class="mr47">
        <div class="c-footer-copyright">{{ baseData.copyright.left1 }}</div>
        <div class="c-footer-copyright">{{ baseData.copyright.left2 }}</div>
      </div>
      <div>
        <div class="c-footer-copyright">{{ baseData.copyright.right1 }}</div>
        <div class="c-footer-copyright">{{ baseData.copyright.right2 }}</div>
      </div>
    </div>

  </div>
</template>

<script>
import { footerData } from './config.js'
import { getFromPage, getPageName } from '@/common/utils/index'
import infoCollect from '@/common/infoCollect';

export default {
  name: 'c-footer',
  data() {
    return {
      baseData: footerData,
      foldMenu: {
        price: false,
        support: false,
        community: false,
        service: false,
      }
    }
  },
  methods: {
    openUrl(url, info) {
      infoCollect.dwCollectData('button_click', info, 'PC', 
        {'page_name': getPageName(), 'from_item': getFromPage()}
      )
      sessionStorage.removeItem('PAGE_SCROLL_TOP_CACHE_PC')
      if (url.startsWith('http')) {
        location.href = url;
      } else {
        this.$router.push(url)
      }
    },
    clickType(type) {
      this.foldMenu[type] = !this.foldMenu[type];
    }
  }
}
</script>

<style lang="scss" scoped>
.c-footer {
  min-height: 10vh;
  min-width: 768px;
  position: relative;

  &-content {
    max-width: 1264px;
    min-width: 704px;
    padding: 0px 32px;
    margin: 0 auto;
  }

  &-logo {
    width: 172px;
    height: 36px;
    margin-top: 48px;
    margin-bottom: 17px;
  }

  &-split {
    width: 100%;
    height: 1px;
    position: relative;
    background: rgba(13, 13, 13, 0.12);
  }

  &-ver-split {
    height: 318px;
    width: 1px;
    background: rgba(13, 13, 13, 0.12);
    margin-right: 100px;
    margin-left: 15px;
  }

  &-block {
    margin: 0 auto;
  }

  &-main {
    display: flex;
    margin: 0 auto;
    max-width: 1264px;
    align-content: center;
    padding: 0px 32px;
    padding-top: 48px;
  }

  &-list:not(:last-child) {
    margin-right: 110px;
  }

  &-list-type {
    font-weight: 700;
    font-size: 20px;
    line-height: 26px;
    color: rgba(13, 13, 13, 0.9);
    margin-bottom: 7px;
    white-space: nowrap;
    background-size: 20px 20px;
    background-repeat: no-repeat;
    background-position: left center;
  }

  &-list-label {
    font-size: 14px;
    line-height: 18px;
    cursor: pointer;
    color: rgba(13, 13, 13, 0.9);
    padding: 3px 0px;
    margin-top: 18px;
    white-space: nowrap;
  }

  &-copyright-block {
    display: flex;
    margin-top: 11px;
    margin-bottom: 23px;
  }

  &-copyright {
    font-size: 12px;
    line-height: 16px;
    margin-bottom: 0px;
    margin-top: 8px;
    color: rgba(13, 13, 13, 0.46);
  }

  .pl28 {
    padding-left: 28px;
  }

  .mt72 {
    margin-top: 72px;
  }

  .mt4 {
    margin-top: 4px;
  }

  .mb26 {
    margin-bottom: 26px;
  }

  .mr47 {
    margin-right: 47px;
  }

  .qrcodeImg {
    width: 120px;
    height: 120px;
  }
  .indent{
    margin-left: 28px;
  }
}

.c-footer-content1200 {
  display: none;
}

@media (max-width: 1200px) {

  .c-footer-content-greater1200 {
    display: none;
  }

  .c-footer-content1200 {
    display: block;

    .c-footer-mini-logo {
      width: 190px;
      height: 42px;
      margin-top: 48px;
      margin-bottom: 14px;
      margin-left: 32px;
    }

    .c-footer-main {
      display: flex;
      flex-direction: column;
    }

    .c-footer-list-mini-type {
      height: 56px;
      font-size: 14px;
      color: #0d0d0de6;
      height: 56px;
      line-height: 56px;
      border-bottom: 1px solid rgba(13, 13, 13, 0.12);
      position: relative;

      span {
        position: absolute;
        right: 0px;
        text-align: right;
      }

      img {
        width: 20px;
        height: 20px;
        transform: rotate(-90deg);
      }

      .imgTransform {
        transform: rotate(0deg);
      }
    }

    .c-footer-list-mini-label {
      padding-left: 24px;
    }

    .c-footer-min-contact {
      display: flex;
      margin-top: 25px;
    }

    .c-footer-min-contact-label {
      padding-left: 28px;
      font-weight: 600;
      font-size: 20px;
      color: #0D0D0D;
      line-height: 30px;
      background-size: 20px 20px;
      background-repeat: no-repeat;
      background-position: left center;
      margin-right: 24px;
    }

    .c-footer-min-contact-value {
      font-size: 14px;
      color: #0d0d0de6;
      line-height: 22px;
    }
  }
}
</style>
